export default {"src":"/_next/static/media/EmpBranding.f756d467.svg","height":37,"width":41,"blurWidth":0,"blurHeight":0};